module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/media/opponent-khabib-nurmagomedov-mobile.0b07b12d.mp4";